import styled from '@emotion/styled';
import xw from 'xwind';

export const ContentButton = styled.button`
  ${xw`
    z-10 absolute bg-white w-10 h-10 border border-gray-100
    text-gray-200 rounded-full focus:outline-none`}

  margin-top: -5px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);

  width: 40px !important;
  height: 40px !important;

  @media screen and (max-width: 640px) {
    width: 32px !important;
    height: 32px !important;
  }
`;

export const IconWrapper = styled.div<{ arrowPosition: 'left' | 'right' }>`
  ${xw('w-full h-full flex justify-center items-center')}

  padding: ${({ arrowPosition }) =>
    arrowPosition === 'left' ? '2px 3px 0 0' : '2px 0 0 6px'};
`;
